import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["pasteBtn", "pasteDietBtn"]

  connect() {
  }

  copySingle(event) {
    event.preventDefault();
    const menuId = event.currentTarget.dataset.menu
    this.pasteBtnTargets.forEach((paste_btn) => {
      paste_btn.classList.remove("disabled")
      paste_btn.href = `${paste_btn.dataset.baseUrl}&copy=${menuId}`
    })

    // Show flash message for copy
    this.showFlashMessage("Menú copiado", "success")
  }

  copyDiet(event) {
    event.preventDefault();
    const dietId = event.currentTarget.dataset.diet
    this.pasteDietBtnTargets.forEach((paste_btn) => {
      paste_btn.classList.remove("disabled")
      paste_btn.href = `${paste_btn.dataset.baseUrl}&diet=${paste_btn.dataset.diet}&copy=${dietId}`
    })

    // Show flash message for copy
    this.showFlashMessage("Dieta copiada", "success")
  }

  showFlashMessage(message, type) {
    // Find or create flash container with consistent ID
    let flashContainer = document.getElementById('flashes')
    if (!flashContainer) {
      flashContainer = document.createElement('div')
      flashContainer.id = 'flashes'
      document.body.appendChild(flashContainer)
    }

    // Create flash message element with standard styling (top-right, fixed position)
    const flashElement = document.createElement('div')
    flashElement.className = `flash flash-${type} alert alert-dismissible fade show`
    flashElement.setAttribute('role', 'alert')
    flashElement.style.cssText = 'z-index: 9999; position: fixed; top: 10px; right: 10px;'
    flashElement.setAttribute('data-controller', 'flash')
    flashElement.setAttribute('data-flash-auto-dismiss-value', 'true')
    flashElement.setAttribute('data-flash-dismiss-delay-value', '4000')
    flashElement.innerHTML = `
      <span class="w-100 text-center" style="white-space: pre-line;">${message}</span>
      <a data-dismiss="alert" aria-label="Close" class="text-secondary">
        <i class="fas fa-times"></i>
      </a>
    `

    // Add to container
    flashContainer.appendChild(flashElement)

    // Auto-dismiss after 4 seconds (matching the standard flash behavior)
    setTimeout(() => {
      if (flashElement.parentNode) {
        flashElement.style.transition = 'opacity 0.3s ease-out'
        flashElement.style.opacity = '0'
        setTimeout(() => flashElement.remove(), 300)
      }
    }, 4000)
  }
}
